<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IUvlYf/tc-custom/9781488013980.jpg?1738328775817" alt="This image is the cover for the book His Ballerina Bride, Drake Diamonds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Ballerina Bride, Drake Diamonds
      </h1>
      <p class="bookDescription body article font2">
        <b>A jewelry empire CEO falls for a simple salesgirl who was once in the spotlight in this sparkling romance from the <i>USA Today</i>–bestselling author. </b><br/><br/>Debonair Artem Drake has had tongues wagging all over New York since he became surprise CEO of Drake Diamonds. This playboy hopes to bring new life to the storied old business before those rumored bad investments sink the family ship. He’s even plucked an ambitious salesgirl out of the shadows to become the store’s new star designer. But Ophelia Rose isn’t the ingenue she seems. The swanlike beauty’s hiding a past that glimmers as bright as a Drake diamond—she once graced the stage as a professional ballerina . . . until she was forced to take her final curtsy and hide from the limelight. Now can Artem bring her back to center stage? Or will their glittering future together wither under the secrets of the past?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Teri Wilson
      </h2>
      
      <p class="authorDescription body article">Teri Wilson is a romance novelist for Harlequin Books. Her novels UNLEASHING MR. DARCY and THE ART OF US are both now Hallmark Channel Original Movies, and she currently has two other films in production with the Hallmark Channel. Teri has also been a contributing writer at HelloGiggles and Teen Vogue, covering books, pop culture and everything royal. She&#39;s crazy about cute animals, vintage fashion and traveling. Visit her at www.teriwilson.net or on Twitter @TeriWilsonauthr.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?797695d0